var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7618_9762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1252 3.50004V10.2084C10.1252 11.4975 9.081 12.5417 7.79183 12.5417C6.50266 12.5417 5.4585 11.4975 5.4585 10.2084V2.91671C5.4585 2.11171 6.11183 1.45837 6.91683 1.45837C7.72183 1.45837 8.37516 2.11171 8.37516 2.91671V9.04171C8.37516 9.36254 8.11558 9.62504 7.79183 9.62504C7.46808 9.62504 7.2085 9.36254 7.2085 9.04171V3.50004H6.3335V9.04171C6.3335 9.84671 6.98683 10.5 7.79183 10.5C8.59683 10.5 9.25016 9.84671 9.25016 9.04171V2.91671C9.25016 1.62754 8.206 0.583374 6.91683 0.583374C5.62766 0.583374 4.5835 1.62754 4.5835 2.91671V10.2084C4.5835 11.9817 6.02141 13.4167 7.79183 13.4167C9.56225 13.4167 11.0002 11.9817 11.0002 10.2084V3.50004H10.1252Z",
    fill: "#FF5000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7618_9762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachYellow);
export default __webpack_public_path__ + "static/media/attachYellow.58e727d6635a8570ccb6aacbc3a4c664.svg";
export { ForwardRef as ReactComponent };